module.exports = __webpack_public_path__ + "static/media/client-logo-19.f42a3c2b.jpg";